export default "__VITE_PUBLIC_ASSET__7cabe77d__"